// frontend/src/utils/links.ts
//
// Absolute URLs for links that get SHARED OUTSIDE the app (league invites, team
// claim links, etc.). On native, window.location.origin is
// `capacitor://localhost`, which a recipient cannot open, so we fall back to the
// public web domain. On web, origin is already correct (localhost in dev,
// fantasy.futbol in prod), and VITE_WEB_BASE_URL can override either.
import { isNativePlatform } from '@/services/platform';
import { userShareRef } from '@/utils/referral';

const WEB_BASE_URL = (
  (import.meta.env.VITE_WEB_BASE_URL as string | undefined) ||
  (isNativePlatform() ? 'https://fantasy.futbol' : window.location.origin)
).replace(/\/+$/, '');

/** Build an absolute public-website URL from a path like `/season-long/join-league?...`. */
export function webUrl(path: string): string {
  return `${WEB_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

/**
 * Canonical league invite link (shared by the League Created screen and the
 * lobby MembersCard): token-gated join when the league has an invite token,
 * otherwise the open-join URL carrying referral attribution.
 */
export function leagueInviteLink(
  league: { id: number; invite_token?: string | null },
  userId?: number | null,
): string {
  return league.invite_token
    ? webUrl(`/season-long/join-league?league_id=${league.id}&invite=${league.invite_token}`)
    : webUrl(`/season-long/join-league?league_id=${league.id}${userId ? `&ref=${userShareRef(userId)}` : ''}`);
}
